import { jsx as n, jsxs as d, Fragment as q } from "react/jsx-runtime";
import { css as o, keyframes as A } from "@emotion/css";
import S from "@volumental/assets/logos/volumental-round.svg";
import fe from "@volumental/assets/icons/backArrow.svg";
import pe from "@volumental/assets/icons/closeCross.svg";
import { forwardRef as k, createRef as X, useCallback as ge, useState as C, useRef as T, useEffect as J, Fragment as he } from "react";
import me from "@volumental/assets/icons/shrinkDropDown.svg";
import ue from "@volumental/assets/icons/search.svg";
import xe from "@volumental/assets/icons/star.png";
import be from "@volumental/assets/icons/star_active.png";
import * as z from "@radix-ui/react-toggle-group";
import ye from "@volumental/assets/icons/dotBar/dot.active.svg";
import we from "@volumental/assets/icons/dotBar/dot.inactive.svg";
import ve from "@volumental/assets/icons/backArrow.black.svg";
import * as w from "@radix-ui/react-select";
import Q from "@volumental/assets/icons/CheckmarkGreen.svg";
import $e from "@volumental/assets/icons/Star_black.svg";
import * as Y from "@radix-ui/react-radio-group";
import ke from "@volumental/assets/icons/checkMark.svg";
const Ne = "'Lato', sans-serif", Se = {
  bold: "700",
  regular: "400"
}, Ce = {
  regular: "1rem",
  medium: "1.125rem",
  large: "1.75rem",
  extraLarge: "2.25rem"
}, ze = {
  fontFamily: Ne,
  fontWeights: Se,
  fontSizes: Ce,
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    success: "#72E08D",
    error: "#e56a74",
    hidden: "rgba(0,0,0,0)",
    disabled: "rgba(0,0,0,0.10)",
    hint: "rgba(240, 227, 115, 0.60)"
  }
}, i = {
  styles: ze
}, Be = o`
  width: 100%;
  height: 56px;
`, We = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 16px;
  padding: 8px 16px 16px 16px;
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  justify-content: center;
  img {
    height: 21px;
    width: auto;
  }
  p {
    margin-left: 8px;
    color: black;
    font-size: 12px;
  }
`, Fe = o`
  display: flex;
  flex-direction: row;
  margin: 0 16px;
  padding: 8px 16px 16px 16px;
  justify-content: center;
  img {
    height: 24px;
    width: auto;
  }
`, Ie = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 12px;

  img {
    height: 16px;
    width: auto;
  }
  p {
    margin: 0 0 0 4px;
    color: black;
    font-size: 12px;
  }
`, Le = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  img {
    height: 24px;
    width: auto;
  }
`, M = o`
  font-family: ${i.styles.fontFamily};
  font-weight: ${i.styles.fontWeights.regular};
  padding: 16px 16px;
  color: black;
  margin-left: 0px;
  margin-right: 0px;
  justify-content: space-between;
  font-size: 11px;
  text-align: left;
  background: rgba(0, 0, 0, 0.05);
  max-lines: 4;
  overflow: hidden;
  backdrop-filter: blur(10px);
`, E = o`
  position: fixed;
  bottom: 0;
  width: 100%;
`;
function ao({
  ariaLabel: e,
  altText: t,
  limitedBranding: r
}) {
  return /* @__PURE__ */ n("footer", { className: Be, "aria-label": e, children: r ? /* @__PURE__ */ n("div", { className: Fe, children: /* @__PURE__ */ n("img", { src: S, alt: t }) }) : /* @__PURE__ */ d("div", { className: We, children: [
    /* @__PURE__ */ n("img", { src: S, alt: t }),
    /* @__PURE__ */ d("p", { children: [
      "Powered by ",
      /* @__PURE__ */ n("strong", { children: "Volumental" })
    ] })
  ] }) });
}
function je({
  ariaLabel: e,
  altText: t,
  limitedBranding: r,
  children: a
}) {
  return r ? /* @__PURE__ */ n("footer", { className: E, "aria-label": e, children: /* @__PURE__ */ n("div", { className: M, children: /* @__PURE__ */ d("div", { className: Le, children: [
    /* @__PURE__ */ n("img", { src: S, alt: t }),
    a
  ] }) }) }) : /* @__PURE__ */ n("footer", { className: E, "aria-label": e, children: /* @__PURE__ */ d("div", { className: M, children: [
    /* @__PURE__ */ d("div", { className: Ie, children: [
      /* @__PURE__ */ n("img", { src: S, alt: t }),
      /* @__PURE__ */ d("p", { children: [
        "Powered by ",
        /* @__PURE__ */ n("strong", { children: "Volumental" })
      ] })
    ] }),
    a
  ] }) });
}
function lo({
  text: e,
  link: t,
  linkText: r,
  onClickLink: a,
  ariaLabel: l,
  altText: s,
  link2: c,
  linkText2: p,
  limitedBranding: h,
  seperatorText: f
}) {
  return /* @__PURE__ */ n(
    je,
    {
      ariaLabel: l,
      altText: s,
      limitedBranding: h,
      children: /* @__PURE__ */ d("div", { children: [
        e,
        /* @__PURE__ */ n(
          "a",
          {
            href: t,
            style: {
              color: "black",
              paddingLeft: 3,
              paddingRight: 3,
              fontWeight: "bold"
            },
            target: "_blank",
            rel: "noreferrer",
            onClick: a,
            children: r
          }
        ),
        c && p ? /* @__PURE__ */ d(q, { children: [
          f,
          /* @__PURE__ */ n(
            "a",
            {
              href: c,
              style: {
                color: "black",
                paddingLeft: 3,
                fontWeight: "bold"
              },
              target: "_blank",
              rel: "noreferrer",
              children: p
            }
          )
        ] }) : void 0
      ] })
    }
  );
}
function so({
  text: e,
  midText: t,
  privacyLink: r,
  privacyLinkText: a,
  termsLink: l,
  termsLinkText: s,
  darkMode: c = !1,
  onClickLink: p,
  ariaLabel: h
}) {
  return /* @__PURE__ */ n(
    "footer",
    {
      "aria-label": h,
      style: { marginBottom: 16, marginTop: 16, fontSize: "12px" },
      children: /* @__PURE__ */ d("div", { style: { color: c ? "white" : "black" }, children: [
        e,
        /* @__PURE__ */ n(
          "a",
          {
            href: r,
            style: {
              color: "black",
              paddingLeft: 3,
              paddingRight: 3,
              fontWeight: "bold"
            },
            target: "_blank",
            rel: "noreferrer",
            onClick: p,
            children: a
          }
        ),
        t,
        /* @__PURE__ */ n(
          "a",
          {
            href: l,
            style: {
              color: "black",
              paddingLeft: 3,
              paddingRight: 3,
              fontWeight: "bold"
            },
            target: "_blank",
            rel: "noreferrer",
            onClick: p,
            children: s
          }
        )
      ] })
    }
  );
}
const Ae = (e, t, r, a, l, s) => o`
  border-radius: 12px;
  margin-top: ${e};
  margin-bottom: ${t};
  padding: ${l};
  background: ${a};
  display: flex;
  flex-direction: column;
  align-items: ${r};
  ${s && o`
    border-radius: var(--corner-radius-radius-medium, 12px);
    border: 1px solid var(--color-color-disabled, rgba(0, 0, 0, 0.1));
  `}
`;
function R({
  children: e,
  alignItems: t = "flex-start",
  marginTop: r = "24px",
  marginBottom: a = "12px",
  backgroundColor: l = "#f5f5f5",
  applyBorder: s = !1,
  padding: c = "25px"
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: Ae(
        r,
        a,
        t,
        l,
        c,
        s
      ),
      children: e
    }
  );
}
const Re = (e) => o`
  background: ${e};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  min-height: -webkit-fill-available;
  font-family: ${i.styles.fontFamily};
`;
function co({
  children: e,
  backgroundColor: t = i.styles.colors.white,
  ...r
}) {
  return /* @__PURE__ */ n("div", { className: Re(t), ...r, children: e });
}
const Te = A`
  from {
    pointer-events: none;
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
`, Me = A`
  from {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
`, Ee = (e, t) => o`
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
  animation: ${e ? Te : Me} ${t} ease-out;
`;
function fo({
  visible: e,
  animationTime: t = "0.6s",
  onClick: r
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      "aria-hidden": !0,
      className: Ee(e, t),
      onClick: r
    }
  );
}
const Pe = (e, t, r, a) => o`
  display: flex;
  flex: auto;
  flex-direction: column;
  flex-flow: column;
  flex-grow: 1;
  justify-content: ${e};
  padding: ${t ? "0px 0px" : "0px 24px"};
  overflow-y: scroll;
  ${a && o`
    ::-webkit-scrollbar {
      display: none;
    }
  `}
  ${r ? o`
        max-height: calc(100dvh - 112px);
      ` : o`
        height: calc(100dvh - 112px);
      `}
`;
function po({
  children: e,
  justifyContent: t = "flex-start",
  disableGutters: r = !1,
  fitToContent: a = !1,
  disableScrollbar: l = !1,
  onScroll: s,
  ...c
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: Pe(
        t,
        r,
        a,
        l
      ),
      onScroll: s,
      ...c,
      children: e
    }
  );
}
const Ue = (e) => o`
  background-color: transparent;
  border: none;
  background: transparent;
  &:hover {
    cursor: pointer;
  }
  padding: 0;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: ${e ? 0.2 : 1};
`, De = o`
  background-color: transparent;
  border-radius: 50%;
  box-shadow: ${"0rem 0.125rem 0.325rem rgba(0, 0, 0, 0.1)"};
`, j = k(
  ({ iconSrc: e, shadow: t, altText: r, ...a }, l) => {
    const { type: s, disabled: c = !1 } = a;
    return /* @__PURE__ */ n(
      "button",
      {
        className: Ue(c),
        type: s === "submit" ? "submit" : "button",
        disabled: c,
        "aria-disabled": c,
        ref: l,
        ...a,
        children: /* @__PURE__ */ n(
          "img",
          {
            src: e,
            alt: r,
            className: t ? De : void 0
          }
        )
      }
    );
  }
);
j.displayName = "IconButton";
const _e = o`
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: space-between;
`, P = o`
  margin: 16px;
`, W = o`
  flex-grow: 1;
`, Oe = o`
  color: ${i.styles.colors.black};
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 16px;
  text-align: center;
  overflow-wrap: normal;
`, He = o`
  font-family: ${i.styles.fontFamily};
  font-weight: ${i.styles.fontWeights.bold};
  font-size: 14px;
  color: ${i.styles.colors.black};
  border-color: #e5e5e5;
  border-style: solid;
  padding: 8px 16px;
  background: none;
  border-radius: 32px;
  margin-left: 16px;
`;
function go({
  back: e,
  close: t,
  title: r,
  children: a,
  actions: l,
  ariaLabelBack: s,
  ariaLabelClose: c,
  altBack: p,
  altClose: h
}) {
  return /* @__PURE__ */ d("div", { className: _e, children: [
    e ? /* @__PURE__ */ n("div", { className: P, children: /* @__PURE__ */ n(
      j,
      {
        iconSrc: fe,
        onClick: () => {
          e();
        },
        altText: p,
        "aria-label": s
      }
    ) }) : void 0,
    l?.map((f) => /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        className: He,
        onClick: f.onClick,
        "aria-label": f.name,
        children: f.name
      },
      f.name
    )),
    !e && (r || a) ? /* @__PURE__ */ n("div", { className: W }) : void 0,
    /* @__PURE__ */ n("div", { className: W }),
    r ? /* @__PURE__ */ n("div", { className: Oe, role: "heading", "aria-level": 1, children: r }) : a,
    /* @__PURE__ */ n("div", { className: W }),
    t ? /* @__PURE__ */ n("div", { className: P, children: /* @__PURE__ */ n(
      j,
      {
        iconSrc: pe,
        onClick: () => {
          t();
        },
        altText: h,
        "aria-label": c
      }
    ) }) : void 0
  ] });
}
const Ve = A`
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
`, Ge = (e) => o`
  width: ${e};
  height: ${e};
  border-radius: 100%;
  border-color: rgba(0, 0, 0, 0.26) rgba(0, 0, 0, 0.26) transparent;
  border-style: solid;
  border-width: 3px;
  display: inline-block;
  animation: 1s linear 0s infinite normal both running ${Ve};
`;
function Ze({ size: e = "15px" }) {
  return /* @__PURE__ */ n("div", { className: Ge(e) });
}
const ee = o`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  font-size: ${i.styles.fontSizes.regular};
  font-family: ${i.styles.fontFamily};
  font-weight: ${i.styles.fontWeights.bold};
  padding: 15px 26px;
  width: 100%;
  min-height: 51px;
  text-align: center;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.4);
    }
  }
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1) 0ms;
  outline-offset: 2px;
`, Ke = (e) => o`
  ${ee}
  padding: 10px 26px;
  user-select: none;
  cursor: default;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.26);
  background-color: ${"rgba(0, 0, 0, 0.12)"};
  box-shadow: none;
`, qe = (e, t, r) => o`
  ${ee}
  background-color: ${e ? i.styles.colors.disabled : t};
  color: ${r};
`, Xe = (e, t) => e ? t ? o`
      border: rgba(0, 0, 0, 0.2);
    ` : o`
    border: 1px groove black;
  ` : o`
      border: none;
    `, te = k(
  ({
    loading: e = !1,
    backgroundColor: t = i.styles.colors.black,
    forgroundColor: r = i.styles.colors.white,
    showBorder: a = !1,
    ...l
  }, s) => {
    const { disabled: c = !1, children: p } = l;
    return /* @__PURE__ */ n(
      "button",
      {
        className: e ? Ke() : `
        ${qe(c, t, r)}
        ${Xe(a, c)}
      `,
        type: "button",
        disabled: c,
        "aria-disabled": c,
        title: e ? "loading" : "",
        ref: s,
        ...l,
        children: e ? /* @__PURE__ */ n(Ze, {}) : p
      }
    );
  }
);
te.displayName = "Button";
const Je = (e, t) => o`
  position: relative;
  overflow: hidden;
  background-color: ${e ? i.styles.colors.disabled : i.styles.colors.white};
  color: ${i.styles.colors.black};
  border-radius: ${t ? "8px" : "12px"};
  border: ${t ? "1px solid rgba(0, 0, 0, 0.1)" : "none"};
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: ${i.styles.fontFamily};
  padding: ${t ? "12px 12px" : "5px 10px"};
  width: auto;
  text-align: center;
  box-shadow: ${t ? void 0 : "0px 2px 20px rgba(0, 0, 0, 0.1)"};
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1) 0ms;
  outline-offset: 2px;
`, Qe = k(
  ({ showBorder: e = !1, ...t }, r) => {
    const { disabled: a = !1, children: l } = t;
    return /* @__PURE__ */ n(
      "button",
      {
        className: Je(a, e),
        type: "button",
        disabled: a,
        "aria-disabled": a,
        ref: r,
        ...t,
        children: l
      }
    );
  }
);
Qe.displayName = "SmallButton";
const Ye = o`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  font-family: ${i.styles.fontFamily};
  text-align: left;
  background-color: white;
  color: black;
  font-size: 14px;
  min-height: auto;
  padding: 8px;
  max-width: fit-content;
  justify-content: right;
  width: auto;
  border-radius: 12px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 1);
  border-width: 1px;
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1) 0ms;
  outline-offset: 2px;

  :active {
    border: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.4);
    }
  }
`, et = (e) => o`
  position: relative;
  height: 1rem;
  width: 1rem;
  transform: rotate(${e ? 0 : 180}deg);
  margin: 0px 0px 0px 5px;
  padding: 0;
`, tt = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0px 2px;
`, ne = k(
  ({ arrowDirection: e = "UP", altText: t, children: r, ...a }, l) => {
    const { disabled: s = !1 } = a;
    return /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        disabled: s,
        className: Ye,
        tabIndex: 0,
        "aria-disabled": s,
        ref: l,
        ...a,
        style: {
          opacity: s ? "20%" : "100%",
          ...a.style
        },
        children: /* @__PURE__ */ d("div", { className: tt, children: [
          /* @__PURE__ */ n("span", { children: r }),
          /* @__PURE__ */ n(
            "img",
            {
              src: me,
              alt: t,
              className: et(e === "UP")
            }
          )
        ] })
      }
    );
  }
);
ne.displayName = "ArrowButton";
const U = (e, t, r) => {
  const a = oe(e, r).slice(0, t);
  return Object.assign(
    Array.from({ length: t }, () => ""),
    a
  );
}, oe = (e, t) => {
  const r = t ? /[^0-9]/g : /[^A-Za-z]/g;
  return e.replace(r, "");
}, nt = o`
  position: relative;
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  margin: 16px 0;
`, ot = o`
  position: absolute as const;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`, rt = (e) => {
  const t = (r) => e ? i.styles.colors.error : r;
  return o`
    font-family: ${i.styles.fontFamily};
    font-weight: ${i.styles.fontWeights.bold};
    font-size: ${i.styles.fontSizes.extraLarge};
    line-height: 2rem;

    display: block;
    box-sizing: content-box;
    text-align: center;

    background: none;
    border: 0px none;
    outline: none !important;

    width: 42px;
    height: 64px;
    &:not(:first-of-type) {
      margin-left: 8px;
    }

    padding: 1px;
    border: 1px solid ${t("rgba(0, 0, 0, 0.1)")};
    border-radius: 8px;

    &:focus-within,
    &:valid {
      padding: 0;
      border: 2px solid ${t("rgba(0, 0, 0, 1)")};
    }

    ${e && "background-color: rgba(229, 106, 116, 0.1)"};
  `;
};
function ho({
  digits: e,
  onlyNumbers: t,
  onChange: r,
  error: a,
  loading: l,
  ariaLabeledBy: s,
  hiddenTitle: c,
  inputAriaLabel: p,
  inputTitle: h
}) {
  const f = Array.from(
    { length: e },
    () => X()
  ), b = (m) => {
    for (const g of f)
      g.current && (g.current.tabIndex = -1);
    if (m >= 0 && m < f.length) {
      const { current: g } = f[m];
      g && (g.tabIndex = 0, g.focus(), g.setSelectionRange(g.value.length, g.value.length));
    }
  }, x = () => {
    const m = f.findIndex((g) => !g.current?.value);
    return m !== -1 && m < f.length ? m : f.length - 1;
  }, y = (m, g) => {
    const { current: u } = f[g];
    u && (u.value = m);
  }, v = () => {
    if (f.every((m) => m.current?.value.length === 1)) {
      const m = f.map((g) => g.current?.value).join("");
      r?.(m);
    }
    b(x());
  };
  return /* @__PURE__ */ d("div", { className: nt, role: "group", "aria-labelledby": s, children: [
    /* @__PURE__ */ n("span", { id: "code-input-label", className: ot, children: c }),
    f.map((m, g) => /* @__PURE__ */ n(
      "input",
      {
        ref: m,
        disabled: l,
        "aria-disabled": l,
        className: rt(a),
        type: "text",
        maxLength: 1,
        required: !0,
        autoFocus: g === 0,
        tabIndex: g === 0 ? 0 : -1,
        inputMode: t ? "numeric" : "text",
        onFocus: () => {
          const u = x();
          u !== g && b(u);
        },
        "aria-label": `${p} - ${(g + 1).toString()} / ${e.toString()}`,
        title: `${h} - ${(g + 1).toString()} / ${e.toString()}`,
        onPaste: (u) => {
          u.preventDefault();
          const $ = U(
            u.clipboardData.getData("Text"),
            e,
            t
          );
          for (const [N, B] of $.entries())
            y(B, N);
          b(x()), v();
        },
        onChange: (u) => {
          const $ = oe(
            u.target.value,
            t
          );
          if ($.length <= 1)
            y($.slice(-1), g);
          else {
            const N = U(
              $,
              e,
              t
            );
            for (const [B, de] of N.entries())
              y(de, B);
            b(x());
          }
          v();
        },
        onKeyDown: (u) => {
          u.key === "Backspace" && !f[g].current?.value && g > 0 && (y("", g - 1), b(g - 1)), u.currentTarget.setSelectionRange(
            u.currentTarget.value.length,
            u.currentTarget.value.length
          );
        }
      },
      g
    ))
  ] });
}
const it = o`
  font-family: ${i.styles.fontFamily};
  font-size: 14px;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  color: ${i.styles.colors.error};
  background-color: transparent;
  width: 100%;
`;
function mo({
  children: e
}) {
  return /* @__PURE__ */ n("div", { className: it, children: e });
}
const re = o`
  color: ${i.styles.colors.black};
  background-color: transparent;
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 2rem;
  line-height: 43px;
  margin: 0 0 1rem 0;
  white-space: pre-line;
  text-align: left;
`, at = o`
  ${re}
  font-size: 1rem;
  margin: 0;
  font-weight: ${i.styles.fontWeights.bold};
`;
function uo({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ n("h1", { className: re, id: "mySectionHeading", ...t, children: e });
}
function xo({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ n(
    "h2",
    {
      className: at,
      id: "mySecondarySectionHeading",
      ...t,
      children: e
    }
  );
}
const lt = (e) => o`
  background-color: transparent;
  border: none;
  background: ${e ? "#72E08D" : "white"};
  &:hover {
    cursor: pointer;
  }
  padding: 5px 10px;
  width: auto;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`, st = k(
  ({ activationStatus: e, iconSrc: t, iconSrcOnDeactivate: r, altText: a, ...l }, s) => /* @__PURE__ */ n(
    "button",
    {
      className: lt(e),
      type: l.type === "submit" ? "submit" : "button",
      ref: s,
      ...l,
      children: /* @__PURE__ */ n(
        "img",
        {
          src: r && !e ? r : t,
          alt: a
        }
      )
    }
  )
);
st.displayName = "ToggleIconButton";
const ct = o`
  position: relative;
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
`, dt = (e, t, r, a, l) => {
  const s = (c) => t ? i.styles.colors.error : r ? "rgba(0, 0, 0, 0)" : c;
  return o`
    font: inherit;
    display: block;
    box-sizing: content-box;
    background: transparent;
    border: 0px none;
    min-width: 0px;
    width: calc(100% - 16px);
    padding: 0px;
    &:focus {
      font-weight: ${e};
    }
    &::placeholder {
      font-weight: ${i.styles.fontWeights.regular};
    }
    border-radius: 8px;
    line-height: 33px;
    padding: 8px;
    &:focus {
      border: 2px solid
        ${a ? "black" : s("rgba(0, 0, 0, 1)")};
      outline: black;
      padding: 6px;
      ${l && "padding-left: 48px;"}
      ${a && "outline: none;"}
    }
    ${r && "background-color: rgba(0, 0, 0, 0.05)"};
    ${t && "background-color: rgba(229, 106, 116, 0.1)"};
    ${l && "padding-left: 50px;"}
  `;
}, ft = o`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
  margin-left: 8px;
`, pt = o`
  position: absolute;
  left: 16px;
  display: flex;
  align-items: center;
`, gt = o`
  height: 100%;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12%;
`;
function ht({
  type: e,
  onChange: t,
  value: r,
  error: a = !1,
  disabled: l,
  placeholder: s,
  crossClick: c,
  applyBackground: p = !1,
  fontWeight: h = i.styles.fontWeights.bold,
  showSearchIcon: f = !1,
  boarderOnFocus: b = !1,
  ariaLabel: x,
  crossAriaLabel: y,
  searchIconAlt: v
}) {
  const m = ge(
    (g) => {
      t(g.target.value);
    },
    [t]
  );
  return /* @__PURE__ */ d("div", { className: ct, children: [
    /* @__PURE__ */ n(
      "input",
      {
        tabIndex: 0,
        className: dt(
          h,
          a,
          p,
          b,
          f
        ),
        name: "subject",
        type: e,
        onChange: m,
        placeholder: s,
        disabled: l,
        value: r,
        "aria-label": x,
        "aria-disabled": l
      }
    ),
    f ? /* @__PURE__ */ n("div", { className: pt, children: /* @__PURE__ */ n("img", { src: ue, alt: v, className: gt }) }) : void 0,
    a ? /* @__PURE__ */ n(
      "div",
      {
        className: ft,
        onClick: c,
        role: "button",
        tabIndex: 0,
        "aria-label": y,
        onKeyDown: (g) => {
          (g.key === "Enter" || g.key === " ") && c();
        },
        children: /* @__PURE__ */ n(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ n("g", { children: /* @__PURE__ */ n(
              "path",
              {
                d: "M 13.057 12 L 17.249 16.192 L 16.192 17.25 L 11.999 13.057 L 7.807 17.25 L 6.749 16.192 L 10.942 12 L 6.749 7.807 L 7.807 6.75 L 11.999 10.942 L 16.192 6.75 L 17.249 7.807 L 13.057 12 Z M 12 0 C 5.373 0 0 5.373 0 12 C 0 18.627 5.373 24 12 24 C 18.627 24 24 18.627 24 12 C 24 5.373 18.627 0 12 0 Z",
                fill: i.styles.colors.error,
                fillRule: "evenodd"
              }
            ) })
          }
        )
      }
    ) : void 0
  ] });
}
const mt = o`
  display: flex;
  justify-content: center;
  height: 100dvh;
`, ut = o`
  display: flex;
  align-items: center;
`, F = (e) => o`
  width: 16px;
  height: 16px;
  background-color: black;
  border-radius: 50%;
  margin: 0 6px;

  animation-name: blink;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  animation-delay: ${e};

  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
`;
function xt() {
  return /* @__PURE__ */ d("div", { className: ut, children: [
    /* @__PURE__ */ n("div", { className: F("0s") }),
    /* @__PURE__ */ n("div", { className: F("0.2s") }),
    /* @__PURE__ */ n("div", { className: F("0.4s") })
  ] });
}
function bo() {
  return /* @__PURE__ */ n("div", { className: mt, children: /* @__PURE__ */ n(xt, {}) });
}
const bt = (e) => o`
  color: ${i.styles.colors.black};
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: ${i.styles.fontSizes.regular};
  line-height: 21px;
  margin-top: 0.5rem;
  background-color: transparent;
  & strong {
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
  ${e && o`
    ::first-letter {
      text-transform: capitalize;
    }
  `}
`;
function yt({
  capitalizeFirst: e = !1,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ n("div", { className: bt(e), ...r, children: t });
}
const wt = o`
  border: none;
  background: transparent;

  color: ${i.styles.colors.black};
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: ${i.styles.fontSizes.regular};
  line-height: 19px;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 0.3rem;

  margin-top: 2rem;
  margin-bottom: 1rem;
  &:hover {
    cursor: pointer;
  }
  outline-offset: 2px;
`, vt = k(({ ...e }, t) => {
  const { children: r } = e;
  return /* @__PURE__ */ n("button", { className: wt, type: "button", ref: t, ...e, children: r });
});
vt.displayName = "TextButton";
const ie = o`
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  color: ${i.styles.colors.black};
`, $t = o`
  ${ie}
  font-weight: ${i.styles.fontWeights.bold};
  font-size: 21px;
  margin-bottom: 24px;
  margin-top: 24px;
`, kt = o`
  ${ie}
  font-weight: ${i.styles.fontWeights.regular};
  font-size: ${i.styles.fontSizes.regular};
  line-height: 21px;
  margin-bottom: 24px;
`;
function yo({
  proceed: e,
  title: t,
  description: r,
  acceptText: a
}) {
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ n("div", { className: $t, children: t }),
    /* @__PURE__ */ n("div", { className: kt, children: r }),
    /* @__PURE__ */ n("div", { style: { paddingBottom: 30 }, children: /* @__PURE__ */ n(te, { loading: !1, type: "submit", onClick: e, children: a }) })
  ] });
}
const Nt = o`
  height: 140px;
  font: inherit;
  display: block;
  box-sizing: content-box;
  background-color: rgba(0, 0, 0, 0.05);
  border: 2px solid transparent;
  border-radius: 8px;
  min-width: 0px;
  width: calc(100% - 36px);
  padding: 16px;
  &::placeholder {
    font-weight: ${i.styles.fontWeights.regular};
  }
  :focus-within {
    border: 2px solid black;
    outline: none;
  }
`;
function wo({
  onWritingComment: e,
  placeHolderText: t,
  ariaLabel: r
}) {
  const [a, l] = C("");
  return /* @__PURE__ */ n(
    "textarea",
    {
      tabIndex: 0,
      className: Nt,
      placeholder: t,
      value: a,
      onChange: (c) => {
        const p = c.target.value;
        l(p), e(p);
      },
      "aria-label": r
    }
  );
}
const St = o`
  background-color: transparent;
  border: none;
  width: 20%;
  max-height: 64px;
  max-width: 64px;
`, Ct = o`
  color: ${i.styles.colors.black};
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.bold};
  font-size: 16px;
  line-height: normal;
  margin-top: 1rem;
  text-align: center;
`, zt = o`
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 12px;
  line-height: normal;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  color: #00000050;
  white-space: pre-wrap;
  padding-left: 5px;
  padding-right: 10px;
`;
function vo({
  onRatingSelect: e,
  npsTitles: t,
  lowHighLabel: r,
  disableOnTap: a = !1,
  altImage: l
}) {
  const [s, c] = C(0), p = (h) => {
    c(h + 1), e(h + 1);
  };
  return /* @__PURE__ */ d(
    "div",
    {
      style: {
        minHeight: "100px",
        width: "fit-content"
      },
      children: [
        Array.from({ length: 5 }).map((h, f) => /* @__PURE__ */ n(
          "button",
          {
            type: "button",
            className: St,
            onClick: () => {
              p(f);
            },
            tabIndex: 0,
            disabled: s > 0 ? a : !1,
            children: /* @__PURE__ */ n(
              "img",
              {
                src: f < s ? be : xe,
                alt: l,
                width: "100%"
              }
            )
          },
          `star-${f.toString()}`
        )),
        t?.[s - 1] ? /* @__PURE__ */ n("div", { className: Ct, children: t[s - 1] }) : void 0,
        r ? /* @__PURE__ */ d("div", { className: zt, children: [
          /* @__PURE__ */ n("span", { children: r.low }),
          /* @__PURE__ */ n("span", { children: r.high })
        ] }) : void 0
      ]
    }
  );
}
const Bt = o`
  --highlight-width: auto;
  --highlight-x-pos: 0;
  display: flex;
  margin: 8px 0 8px;
`, Wt = (e, t, r) => o`
  display: inline-flex;
  justify-content: space-between;
  padding: ${t ? "6px" : "12px"};
  margin: auto;
  overflow: hidden;
  position: relative;
  background: ${r};
  border-radius: 12px;
  width: 100%;
  position: relative;
  display: flex;
  overflow: hidden;

  &::before {
    content: '';
    background: #ffffff;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 9px;
    width: var(--highlight-width, 0px);
    transform: translateX(var(--highlight-x-pos, 0px));
    position: absolute;
    top: ${t ? "4px" : "8px"};
    bottom: ${t ? "4px" : "8px"};
    left: 0;
    z-index: 0;
    ${o`
      transition:
        transform 0.3s ease,
        width 0.3s ease;
    `}
  }
`, Ft = (e, t) => o`
  all: unset;
  cursor: pointer;
  width: calc(97% / ${t});
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  padding: ${e ? "4px" : "10px"};
  font-size: ${e ? "14px" : "16px"};
  font-weight: ${i.styles.fontWeights.regular};
  z-index: 1;
  position: relative;
  text-align: center;
  transition: color 0.3s ease;

  &:focus-visible {
    outline: 2px solid #444;
    outline-offset: 2px;
  }
`;
function $o({
  options: e,
  selected: t,
  onSelect: r,
  smallContainer: a = !1,
  backgroundColor: l = "rgba(0, 0, 0, 0.05)",
  groupAriaLabel: s
}) {
  const c = T(null), p = T([]);
  J(() => {
    const f = e.findIndex((y) => y.value === t), b = p.current[f], x = c.current;
    if (b && x) {
      const { offsetLeft: y, offsetWidth: v } = b;
      x.style.setProperty(
        "--highlight-width",
        `${v.toString()}px`
      ), x.style.setProperty(
        "--highlight-x-pos",
        `${y.toString()}px`
      );
    }
  }, [t, e]);
  const h = (f) => {
    f && f !== t && r(f);
  };
  return /* @__PURE__ */ n("div", { className: Bt, children: /* @__PURE__ */ n(
    z.Root,
    {
      type: "single",
      value: t,
      onValueChange: h,
      className: Wt(!0, a, l),
      ref: c,
      "aria-label": s,
      style: a ? { width: "100px" } : void 0,
      children: e.map((f, b) => /* @__PURE__ */ n(
        z.Item,
        {
          value: f.value,
          className: ` ${Ft(a, e.length)}`,
          ref: (x) => {
            p.current[b] = x;
          },
          "aria-label": f.label,
          children: f.label
        },
        f.value
      ))
    }
  ) });
}
const It = o`
  display: grid;
  grid-template-columns: 50px auto 50px;
  width: 100%;
  justify-items: center;
  background-color: transparent;
  &:focus-visible {
    outline: 1px solid blue;
  }
`, Lt = o`
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 3px;
  width: 100%;
  container-type: inline-size;
`, jt = o`
  width: 100%;
  height: 4px;
  background: #000000;
  align-self: center;
`, D = o`
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  background-color: transparent;
  color: ${i.styles.colors.black};
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 12px;
  overflow: hidden;
  line-height: 30px;
  align-content: center;
  width: 100%;
`, _ = (e) => o`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(calc(${e}cqw - 50%));
  transition: transform 0.3s ease-in-out;
`, O = o`
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  color: ${i.styles.colors.black};
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 12px;
`;
function At() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "10",
      height: "9",
      viewBox: "0 0 12 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M5.20753 1.02937C5.60784 0.509358 6.39204 0.509358 6.79235 1.02937L11.6888 7.39001C12.195 8.04757 11.7262 9 10.8964 9H1.10351C0.273676 9 -0.195087 8.04757 0.31111 7.39001L5.20753 1.02937Z",
          fill: "#000"
        }
      )
    }
  );
}
function Rt() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "10",
      height: "9",
      viewBox: "0 0 12 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M6.79241 7.97063C6.3921 8.49064 5.6079 8.49064 5.20759 7.97063L0.311171 1.60999C-0.195026 0.952425 0.273738 0 1.10358 0L10.8964 0C11.7263 0 12.195 0.952425 11.6888 1.60999L6.79241 7.97063Z",
          fill: "#000"
        }
      )
    }
  );
}
function Tt({
  startLabel: e,
  endLabel: t,
  arrowDown: r,
  arrowUp: a
}) {
  const l = Math.floor(
    (r.value + a.value) / 2 / 100 * 5
  ), s = Array.from({ length: 5 }, (c, p) => `box-${(p + 1).toString()}`);
  return /* @__PURE__ */ d("div", { className: It, children: [
    /* @__PURE__ */ n("div", { className: D, style: { textAlign: "left" }, children: e }),
    /* @__PURE__ */ d("div", { className: Lt, children: [
      s.map((c, p) => /* @__PURE__ */ n(
        "div",
        {
          className: jt,
          style: {
            opacity: l === p ? 1 : 0.1
          }
        },
        c
      )),
      /* @__PURE__ */ d(
        "div",
        {
          className: _(r.value.toString()),
          style: {
            top: "-12px"
          },
          children: [
            /* @__PURE__ */ n("span", { className: O, children: r.label }),
            /* @__PURE__ */ n(Rt, {})
          ]
        }
      ),
      /* @__PURE__ */ d(
        "div",
        {
          className: _(a.value.toString()),
          style: {
            top: "18px"
          },
          children: [
            /* @__PURE__ */ n(At, {}),
            /* @__PURE__ */ n("span", { className: O, children: a.label })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n("div", { className: D, style: { textAlign: "right" }, children: t })
  ] });
}
const ae = o`
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  color: ${i.styles.colors.black};
`, Mt = o`
  display: flex;
  flex-direction: column;
  width: 100%;
`, Et = o`
  ${ae}
  font-weight: ${i.styles.fontWeights.bold};
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
`, Pt = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
`, H = o`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${ae}
`, Ut = o`
  width: 3px;
  height: 100%;
  opacity: 0.1;
  border-radius: 20px;
  background: #000;
  align-self: center;
  margin: 0px 40px;
`;
function ko({
  title: e,
  compareData: t,
  measurementData: r,
  marginBottom: a = "0px",
  marginTop: l = "0px"
}) {
  return /* @__PURE__ */ n(
    R,
    {
      backgroundColor: "white",
      applyBorder: !0,
      marginBottom: a,
      marginTop: l,
      children: /* @__PURE__ */ d("div", { className: Mt, children: [
        /* @__PURE__ */ n("div", { className: Et, children: e }),
        t ? /* @__PURE__ */ n("div", { style: { width: "100%" }, children: /* @__PURE__ */ n(
          Tt,
          {
            startLabel: t.startLabel,
            endLabel: t.endLabel,
            arrowUp: t.arrowUp,
            arrowDown: t.arrowDown
          }
        ) }) : void 0,
        r ? /* @__PURE__ */ d("div", { className: Pt, children: [
          /* @__PURE__ */ d("div", { className: H, children: [
            /* @__PURE__ */ n("span", { style: { fontSize: "12px" }, children: r.left.label }),
            /* @__PURE__ */ n("span", { style: { fontSize: "16px", fontWeight: "bold" }, children: r.left.value })
          ] }),
          /* @__PURE__ */ n("div", { className: Ut }),
          /* @__PURE__ */ d("div", { className: H, children: [
            /* @__PURE__ */ n("span", { style: { fontSize: "12px" }, children: r.right.label }),
            /* @__PURE__ */ n("span", { style: { fontSize: "16px", fontWeight: "bold" }, children: r.right.value })
          ] })
        ] }) : void 0
      ] })
    }
  );
}
const Dt = o`
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
`, _t = o`
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  padding: 16px 0px;
  background: #ecf0eb;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`, Ot = (e) => o`
  width: 100%;
  padding: 24px 0px;
  display: flex;
  flex-direction: column;
  align-items: ${e};
  background: transparent;
`;
function No({
  children: e,
  title: t,
  alignItems: r = "center"
}) {
  return /* @__PURE__ */ d("div", { className: Dt, children: [
    /* @__PURE__ */ n("div", { className: _t, children: t }),
    /* @__PURE__ */ n("div", { className: Ot(r), children: e })
  ] });
}
const Ht = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  align-content: center;
  justify-content: center;
  background: transparent;
`, Vt = o`
  padding: 0.6rem;
  align-items: center;
  align-self: center;
  align-content: center;
  justify-content: center;
  max-height: 0.7rem;
  max-width: 0.7rem;
`;
function So({
  activeStep: e,
  stepsCount: t,
  altText: r
}) {
  return /* @__PURE__ */ n("div", { className: Ht, children: Array.from({ length: t }, (a, l) => /* @__PURE__ */ n(
    "img",
    {
      src: e === l ? ye : we,
      alt: r,
      className: Vt
    },
    `dot-${l.toString()}`
  )) });
}
const Gt = o`
  padding-right: 0.5rem;
  font-size: ${i.styles.fontSizes.medium};
  font-weight: ${i.styles.fontWeights.bold};
  color: black;
  background-color: transparent;
`, Zt = o`
  aspect-ratio: 1;
  align-self: stretch;
  border-radius: 12px;
`, Kt = o`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding-right: 0.5rem;
  background-color: transparent;
`, qt = o`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: transparent;
  gap: 8px;
  max-width: 33%;
  min-width: 28%;
`, le = o`
  margin: 0;
  padding: 0;
  list-style-type: none;
  background-color: transparent;
`, Xt = o`
  ${le}
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;
  font-size: 16px;
`, se = o`
  color: black;
  background-color: transparent;
`;
function Co({
  bulletPoints: e
}) {
  return /* @__PURE__ */ n("ul", { className: le, children: e.map((t) => /* @__PURE__ */ d("li", { className: Kt, children: [
    /* @__PURE__ */ n("div", { className: Gt, children: "•" }),
    /* @__PURE__ */ n("div", { className: se, children: t })
  ] }, t)) });
}
function zo({
  bulletPoints: e
}) {
  return /* @__PURE__ */ n("ul", { className: Xt, children: e.map((t, r) => /* @__PURE__ */ d("li", { className: qt, children: [
    /* @__PURE__ */ n(
      "img",
      {
        className: Zt,
        src: t.img,
        alt: `${r.toString()}-${t.text}`
      }
    ),
    /* @__PURE__ */ n("div", { className: se, children: t.text })
  ] }, t.text)) });
}
const Jt = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  height: 5rem;
  width: 100%;
  background: white;
  border-radius: 1rem;
  border-color: ${i.styles.colors.disabled};
  margin-bottom: 1.25rem;
  border-width: 0.07rem;
  border-style: solid;
`, Qt = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 24px;
`, ce = o`
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 0;
  font-style: normal;
  font-family: ${i.styles.fontFamily};
  font-weight: ${i.styles.fontWeights.bold};
  font-size: 21px;
  line-height: 22px;
  text-align: left;
`, Yt = o`
  ${ce}
  font-size: 14px;
  font-weight: ${i.styles.fontWeights.regular};
`, en = o`
  display: flex;
  flex-direction: column;
  gap: 4px;
`, tn = o`
  position: relative;
  height: 1.7rem;
  width: 1.7rem;
  transform: rotate(180deg);
  margin: 0;
  padding: 0;
`, nn = k(({ text: e, description: t, altText: r, ...a }, l) => /* @__PURE__ */ n(
  "button",
  {
    className: Jt,
    type: "button",
    ref: l,
    ...a,
    style: { color: "black", ...a.style },
    children: /* @__PURE__ */ d("div", { className: Qt, children: [
      /* @__PURE__ */ d("div", { className: en, children: [
        /* @__PURE__ */ n("span", { className: ce, children: e }),
        t ? /* @__PURE__ */ n("span", { className: Yt, children: t }) : void 0
      ] }),
      /* @__PURE__ */ n("img", { className: tn, src: ve, alt: r })
    ] })
  }
));
nn.displayName = "SelectArrowButton";
const Bo = /Mobi/i.test(globalThis.navigator.userAgent), Wo = (e) => e ? !!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/.test(e) : !1;
function on(e) {
  return rn.get(e) ?? e;
}
const rn = /* @__PURE__ */ new Map([
  ["EU", "EU"],
  ["UK", "UK"],
  ["US", "US"],
  ["US_WOMEN", "US Women"],
  ["US_MEN", "US Men"],
  ["MONDOPOINT", "Mondopoint"],
  ["AU_WOMEN", "AU Women"],
  ["AU_MEN", "AU Men"],
  ["SKATE_SIZE", "Skate Size"]
]);
function V(e) {
  const t = e * 1e3;
  return String(Math.round(t) / 10);
}
function G(e) {
  const t = e * 39.3701;
  return String(Math.round(t * 10) / 10);
}
function Z(e, t) {
  return t === "inches" ? `${G(e.min)} - ${G(e.max)}` : `${V(e.min)} - ${V(e.max)}`;
}
function K(e) {
  return e.every((t) => t.footWidth !== void 0);
}
const an = o`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: ${i.styles.fontFamily};
  font-size: 14px;
  text-align: center;
`, ln = o`
  position: sticky;
  top: 0;
  z-index: 2;
  background: white;
  outline: 1px solid white;
`, I = o`
  background: rgba(227, 233, 226, 1);
  padding: 19px 12px;
  font-weight: 700;
  :first-child {
    border-radius: 12px 0 0 0;
  }
  :last-child {
    border-radius: 0 12px 0 0;
  }
`, sn = o`
  border: 1px solid rgba(0, 0, 0, 0.1);
`, L = o`
  font-weight: 400;
  padding: 19px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
function Fo({
  sizeList: e,
  lengthUnit: t,
  lengthTitle: r,
  widthTitle: a,
  sizeLocale: l
}) {
  return /* @__PURE__ */ d("table", { className: an, children: [
    /* @__PURE__ */ n("thead", { className: ln, children: /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ n("th", { className: I, children: r }),
      K(e) ? /* @__PURE__ */ n("th", { className: I, children: a }) : void 0,
      /* @__PURE__ */ n("th", { className: I, children: on(l) })
    ] }) }),
    /* @__PURE__ */ n("tbody", { className: sn, children: e.map((s, c) => /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ n("td", { className: L, children: Z(s.footLength, t) }),
      K(e) ? /* @__PURE__ */ n("td", { className: L, children: Z(s.footWidth, t) }) : void 0,
      /* @__PURE__ */ n("td", { className: L, children: s.localizedSizes.find((p) => p.locale === l)?.label })
    ] }, c)) })
  ] });
}
const cn = o`
  display: flex;
  flex-direction: row;
  align-content: space-between;
  background: transparent;
  width: 100%;
  gap: 8px;
`, dn = o`
  flex-grow: 1;
  height: 4px;
  border-radius: 8px;
  background: black;
`, fn = o`
  flex-grow: 1;
  height: 4px;
  border-radius: 8px;
  background: black;
  opacity: 0.1;
`;
function Io({
  activeStep: e,
  stepsCount: t
}) {
  return /* @__PURE__ */ n("div", { className: cn, children: Array.apply(0, Array.from({ length: t })).map((r, a) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ n("div", { className: a === e ? dn : fn }, a)
  )) });
}
const pn = (e) => o`
  display: grid;
  grid-template-columns: ${e ? "minmax(200px, 1fr)" : "repeat(auto-fit, minmax(100px, 1fr))"};
  @media (min-width: 480px) {
    grid-template-columns: ${e ? "minmax(200px, 1fr)" : "repeat(auto-fit, minmax(120px, 1fr))"};
  }
  gap: ${e ? "16px" : "8px"};
  grid-auto-flow: row;
  overflow-y: auto;
  overflow-x: hidden;
`, gn = o`
  align-items: center;
  font-size: 16px;
  font-family: ${i.styles.fontFamily};
  color: black;
  ::first-letter {
    text-transform: capitalize;
  }
`, hn = (e, t) => o`
  background-color: #ffff;
  border: ${e ? "1px solid #000" : "1px solid rgba(0, 0, 0, 0.10)"};
  border-radius: 12px;
  padding: ${t ? "24px 16px" : "16px"};
  text-align: center;
  transition: transform 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
  }
`;
function Lo({
  options: e,
  selected: t,
  onSelect: r,
  groupAriaLabel: a,
  singleColumnMode: l = !1
}) {
  return /* @__PURE__ */ n("div", { className: pn(l), "aria-label": a, children: e.map((s) => /* @__PURE__ */ n(
    "button",
    {
      className: hn(
        !!(t && t === s.value),
        l
      ),
      onClick: () => {
        r(s.value);
      },
      type: "button",
      children: /* @__PURE__ */ n("div", { className: gn, children: s.label })
    },
    s.label
  )) });
}
const mn = o`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 8rem;
  min-width: 8rem;
  max-height: 400px;
  justify-items: center;
  justify-self: center;
  align-self: center;
  justify-content: center;
`, un = o`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
`;
function jo({
  src: e,
  alt: t,
  ...r
}) {
  return /* @__PURE__ */ n("div", { className: mn, ...r, children: /* @__PURE__ */ n("img", { src: e, className: un, alt: t }) });
}
const xn = o`
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
`, bn = o`
  font-family: ${i.styles.fontFamily};
  background: white;
  border: 1px solid black;
  border-radius: 12px;
  padding: 4px 0;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  z-index: 10;
  width: var(--radix-select-trigger-width);
`, yn = o`
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  color: black;
  text-align: left;
  cursor: pointer;
  justify-content: space-between;
`, wn = o`
  width: 16px;
  height: 16px;
`;
function Ao({
  options: e,
  selected: t,
  btAlt: r,
  selectedItemAlt: a,
  onSelect: l,
  groupAriaLabel: s
}) {
  const c = e.find(
    (p) => p.value === t
  ) ?? { label: t };
  return /* @__PURE__ */ d(w.Root, { value: t, onValueChange: l, children: [
    /* @__PURE__ */ n(w.Trigger, { asChild: !0, children: /* @__PURE__ */ n(
      ne,
      {
        arrowDirection: "DOWN",
        style: {
          borderColor: "rgba(0, 0, 0, 0.1)",
          color: "black",
          width: "100%",
          maxWidth: "100%"
        },
        altText: r,
        "aria-label": t,
        children: c.label
      }
    ) }),
    /* @__PURE__ */ n(w.Portal, { children: /* @__PURE__ */ n(
      w.Content,
      {
        className: bn,
        position: "popper",
        sideOffset: 10,
        "aria-label": s,
        children: /* @__PURE__ */ n(w.Viewport, { children: e.map((p, h) => /* @__PURE__ */ d(w.Group, { children: [
          /* @__PURE__ */ d(w.Item, { value: p.value, className: yn, children: [
            /* @__PURE__ */ n(w.ItemText, { children: p.label }),
            /* @__PURE__ */ n(w.ItemIndicator, { children: /* @__PURE__ */ n(
              "img",
              {
                src: Q,
                alt: a,
                className: wn
              }
            ) })
          ] }),
          h < e.length - 1 && /* @__PURE__ */ n(w.Separator, { className: xn })
        ] }, p.label)) })
      }
    ) })
  ] });
}
const vn = o`
  display: flex;
  flex-direction: row;
  width: fit-content;
  gap: 4px;
`;
function Ro({
  rate: e,
  altText: t
}) {
  return /* @__PURE__ */ n("div", { className: vn, children: Array.from({ length: 5 }).map((r, a) => /* @__PURE__ */ n(
    "div",
    {
      style: { opacity: a < e ? 1 : 0.1 },
      children: /* @__PURE__ */ n("img", { src: $e, alt: t, width: "100%" })
    },
    `star-${a.toString()}`
  )) });
}
const $n = o`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  justify-content: left;
`;
function To({
  children: e,
  iconSrc: t,
  iconAlt: r,
  marginTop: a = "16px"
}) {
  return /* @__PURE__ */ n(
    R,
    {
      backgroundColor: i.styles.colors.hint,
      alignItems: "left",
      padding: "16px",
      marginBottom: "0px",
      marginTop: a,
      children: /* @__PURE__ */ d("div", { className: $n, children: [
        /* @__PURE__ */ n("img", { src: t, style: { paddingRight: "16px" }, alt: r }),
        e
      ] })
    }
  );
}
const kn = o`
  display: flex;
  flex-direction: row;
`, Nn = o`
  width: 4px;
  border-radius: 2px;
  background-color: ${i.styles.colors.hint};
  margin-right: 8px;
`;
function Mo({
  children: e
}) {
  return /* @__PURE__ */ d("div", { className: kn, children: [
    /* @__PURE__ */ n("span", { className: Nn }),
    e
  ] });
}
const Sn = o`
  list-style: none;
`, Cn = (e) => o`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 84px;
  background: #ffffff;
  border: ${e ? "2px solid black" : "1px solid rgba(0, 0, 0, 0.1)"};
  padding: ${e ? "0" : "1px"};
  border-radius: 12px;
  margin: 16px 0;
  cursor: pointer;
`, zn = o`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 20px;
`, Bn = o`
  margin-left: 10px;
  font-weight: ${i.styles.fontWeights.bold};
  line-height: 24px;
`, Wn = o`
  margin-top: 4px;
  margin-left: 10px;
  font-family: ${i.styles.fontFamily};
  font-style: normal;
  font-weight: ${i.styles.fontWeights.regular};
  font-size: 12px;
  line-height: 18px;
  color: ${i.styles.colors.black};
`, Fn = o`
  position: relative;
  align-self: center;
  margin-right: 24px;
  height: 24px;
  width: 24px;
`, In = (e) => o`
  background-color: ${e ? i.styles.colors.success : i.styles.colors.white};
  border: 2px solid
    ${e ? i.styles.colors.success : i.styles.colors.black};
  border-radius: 50%;
  height: 20px;
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
`, Ln = (e) => o`
  fill: ${i.styles.colors.success};
  position: relative;
  left: 4px;
  top: 1px;
  visibility: ${e ? "visible" : "hidden"};
`;
function jn({
  item: e,
  isSelected: t,
  title: r,
  checkAlt: a
}) {
  return /* @__PURE__ */ n(
    Y.Item,
    {
      className: Cn(t),
      "aria-label": r,
      value: e.id,
      asChild: !0,
      children: /* @__PURE__ */ d("li", { className: Sn, children: [
        /* @__PURE__ */ d("div", { className: zn, children: [
          /* @__PURE__ */ n("div", { className: Bn, children: r }),
          /* @__PURE__ */ n("div", { className: Wn, children: new Date(e.createdAt).toLocaleString(
            globalThis.navigator.language
          ) })
        ] }),
        /* @__PURE__ */ n("div", { className: Fn, children: /* @__PURE__ */ n("div", { className: In(t), children: /* @__PURE__ */ n(
          "img",
          {
            className: Ln(t),
            src: ke,
            alt: a
          }
        ) }) })
      ] })
    }
  );
}
const An = o`
  margin-left: 0px;
  padding-left: 0px;
  overflow-y: auto;
`;
function Eo({
  items: e,
  selectedId: t,
  onSelect: r,
  titles: a,
  selectIconAlt: l
}) {
  return /* @__PURE__ */ n(
    Y.Root,
    {
      className: An,
      value: t,
      onValueChange: r,
      asChild: !0,
      children: /* @__PURE__ */ n("ul", { children: e.map((s) => /* @__PURE__ */ n(
        jn,
        {
          item: s,
          isSelected: s.id === t,
          title: s.type === "RetailScan" ? a.instore : a.webscanner,
          checkAlt: l
        },
        s.id
      )) })
    }
  );
}
const Rn = o`
  display: flex;
  margin: 8px 0 8px;
`, Tn = o`
  display: inline-flex;
  gap: 8px;
  margin: auto;
  width: 100%;
`, Mn = o`
  all: unset;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 9999px;
  font-family: ${i.styles.fontFamily};
  font-size: 14px;
  font-weight: ${i.styles.fontWeights.regular};
  text-align: center;
  transition: all 0.2s ease-in-out;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  color: #000000;

  &:hover {
    border-color: rgba(0, 0, 0, 0.3);
  }

  &:focus-visible {
    outline: 2px solid #444;
    outline-offset: 2px;
  }

  &[data-state='on'] {
    background-color: #000000;
    color: #ffffff;
    border-color: #000000;
  }
`;
function Po({
  options: e,
  selected: t,
  onSelect: r,
  groupAriaLabel: a
}) {
  return /* @__PURE__ */ n("div", { className: Rn, children: /* @__PURE__ */ n(
    z.Root,
    {
      type: "single",
      value: t,
      onValueChange: (l) => {
        l && r(l);
      },
      className: Tn,
      "aria-label": a,
      children: e.map((l) => /* @__PURE__ */ n(
        z.Item,
        {
          value: l.value,
          className: Mn,
          "aria-label": l.label,
          children: l.label
        },
        l.value
      ))
    }
  ) });
}
const En = o`
  margin: 1px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  min-height: 51px;
  background-color: white;
  display: flex;
  align-items: center;
  font-size: ${i.styles.fontSizes.regular};
  font-family: ${i.styles.fontFamily};
  padding-left: 16px;
  border: transparent;
`, Pn = o`
  height: 1px;
  min-height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
`, Un = o`
  position: absolute;
  right: 5%;
  max-height: 25px;
  max-width: 25px;
`, Dn = o`
  display: flex;
  flex: auto;
  flex-direction: column;
  flex-flow: column;
  flex-grow: 1;
  overflow-y: scroll;
  margin-top: 10px;
  margin-bottom: 10px;
`, _n = o`
  height: 100%;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12%;
`;
function On({
  options: e,
  selected: t,
  onSelect: r,
  checkMarkAltText: a,
  groupAriaLabel: l
}) {
  const s = X();
  return J(() => {
    s.current && t && s.current.focus();
  }, [s, t]), /* @__PURE__ */ n("div", { className: Dn, "aria-label": l, children: e.map((c, p) => /* @__PURE__ */ d(he, { children: [
    /* @__PURE__ */ d(
      "button",
      {
        className: En,
        type: "button",
        onClick: () => {
          r(c.value);
        },
        children: [
          /* @__PURE__ */ n(yt, { children: c.label }),
          t === c.value && /* @__PURE__ */ n("div", { className: Un, children: /* @__PURE__ */ n(
            "img",
            {
              src: Q,
              alt: a,
              className: _n
            }
          ) })
        ]
      }
    ),
    p !== e.length - 1 && /* @__PURE__ */ n("div", { className: Pn })
  ] }, c.label)) });
}
function Uo({
  options: e,
  selected: t,
  onSelect: r,
  placeHolder: a,
  groupAriaLabel: l,
  noMatchDescription: s,
  noMatchTitle: c,
  ariaSearchLabel: p,
  checkMarkAltText: h,
  crossAriaLabel: f,
  searchIconAlt: b
}) {
  const [x, y] = C(e), [v, m] = C("");
  return /* @__PURE__ */ d(q, { children: [
    /* @__PURE__ */ n(
      ht,
      {
        value: v,
        onChange: (u) => {
          m(u);
          const $ = e.filter(
            (N) => N.label.toLowerCase().includes(u.toLowerCase()) || N.value.toLowerCase().includes(u.toLowerCase())
          );
          y($);
        },
        applyBackground: !0,
        type: "search",
        boarderOnFocus: !0,
        showSearchIcon: !0,
        crossClick: () => {
          m("");
        },
        placeholder: a,
        ariaLabel: p,
        crossAriaLabel: f,
        searchIconAlt: b
      }
    ),
    x.length === 0 && /* @__PURE__ */ d(R, { children: [
      /* @__PURE__ */ n(
        "span",
        {
          style: {
            fontWeight: i.styles.fontWeights.bold,
            fontSize: "21px",
            opacity: "0.5"
          },
          children: `${c}"${v}"`
        }
      ),
      /* @__PURE__ */ n(
        "span",
        {
          style: {
            fontWeight: i.styles.fontWeights.regular,
            fontSize: "16px",
            opacity: "0.5",
            paddingTop: "16px"
          },
          children: s
        }
      )
    ] }),
    /* @__PURE__ */ n(
      On,
      {
        options: x,
        selected: t,
        onSelect: r,
        groupAriaLabel: l,
        checkMarkAltText: h
      }
    )
  ] });
}
export {
  yo as AgeRestrictionModal,
  ne as ArrowButton,
  fo as BackDrop,
  jo as BannerImage,
  R as BoxContainer,
  No as BoxWithColoredHeader,
  ao as BrandingFooter,
  Co as BulletPoints,
  te as Button,
  Lo as ButtonGridView,
  ho as CodeInput,
  wo as CommentBox,
  Tt as CompareRuler,
  co as Container,
  po as Content,
  Ro as DisabledStar,
  So as DotBar,
  Ao as Dropdown,
  mo as ErrorText,
  go as Header,
  uo as Headline,
  xo as Headline2,
  Mo as HighlightBar,
  To as HighlightBox,
  j as IconButton,
  zo as ImageBulletPoints,
  ht as Input,
  Uo as ListGridSearchBar,
  bo as Loader,
  xt as LoaderDots,
  ko as MeasurementBox,
  Po as PillSelector,
  lo as PrivacyBox,
  so as PrivacyTerms,
  Io as ProgressBar,
  Eo as ScanList,
  $o as SegmentedButton,
  nn as SelectArrowButton,
  Fo as SizeTable,
  Qe as SmallButton,
  Ze as Spinner,
  vo as StarRating,
  yt as Text,
  vt as TextButton,
  st as ToggleIconButton,
  on as formatLocale,
  Bo as isMobileDevice,
  Wo as isValidEmail,
  i as uiConfig
};
